import { render, staticRenderFns } from "./InstagramIcon.vue?vue&type=template&id=2f74be48&scoped=true&"
import script from "./InstagramIcon.vue?vue&type=script&lang=js&"
export * from "./InstagramIcon.vue?vue&type=script&lang=js&"
import style0 from "./InstagramIcon.vue?vue&type=style&index=0&id=2f74be48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74be48",
  null
  
)

export default component.exports